/* __next_internal_client_entry_do_not_use__ RetailerRoutingContextProvider,useRetailerRoutingContext auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { getTwoLetterLanguageCode } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { convertLocaleToCountryLocaleString } from "@faire/web--source/common/localization/languageWithCountryOptions";
import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { NextLink } from "@faire/web--source/ui/NextLink";
import { RoutingContext } from "@faire/web--source/ui/routing/RoutingContext";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import React from "react";
import { getFaireDirectBrandAlias } from "./serialized-data/getFaireDirectBrandAlias";
import { getFaireDirectBrandToken } from "@faire/retailer-visitor-shared/serialized-data/getFaireDirectBrandToken";
export var RetailerRoutingContextProvider = function(props) {
    var _useLocalization = useLocalization(), locale = _useLocalization.intl.locale;
    var canonicalLocale = getTwoLetterLanguageCode(Language.ENG).toLowerCase();
    var localeCountryUrlPrefix = getGlobalProperty("localeCountryUrlPrefix");
    var _getGlobalProperty;
    var availableLanguageSelectorLocales = ((_getGlobalProperty = getGlobalProperty("availableLanguageSelectorLocales")) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : []).map(function(iLocaleKey) {
        return convertLocaleToCountryLocaleString(iLocaleKey);
    });
    var faireDirectBrandToken = getFaireDirectBrandToken();
    var faireDirectBrandAlias = getFaireDirectBrandAlias();
    return /*#__PURE__*/ _jsx(RoutingContext.Provider, {
        value: _object_spread_props(_object_spread({
            locale: locale,
            canonicalLocale: canonicalLocale,
            localeCountryUrlPrefix: localeCountryUrlPrefix,
            allowedRobotLocales: availableLanguageSelectorLocales
        }, !isPrerender() ? {
            faireDirectBrandAlias: faireDirectBrandAlias,
            faireDirectBrandToken: faireDirectBrandToken
        } : null), {
            Link: props.useNextLink ? NextLink : undefined
        }),
        children: props.children
    });
};
export var useRetailerRoutingContext = function() {
    return React.useContext(RoutingContext);
};
